import React from 'react';
import Modal from '../Modal/Modal';
import CalendarPatientEvent from './CalendarPatientEvent';
import { useTreatmentContext } from '../../Services/TreatmentContext';
import { IResponse } from '../../Services/ApiClient';
// @ts-ignore
import styles from './CalendarTermPicker.module.scss';
import { HealthPlanCode } from '../../Enums/HealthPlanCode.enum';
import { Calendar } from '../../graphql/graphql';

interface ICalendarPatientEventModal {
	opened: boolean;
	onClose: () => void;
	onEventIsCreated?: (response: IResponse) => void;
	selectedDate: any;
	patientId?: string;
	caseId?: string;
	workplaceId?: string;
	defaultData?: any;
	params?: any;
	meddibaby?: boolean;
	healthPlanCode?: HealthPlanCode;
	onSuccess?: () => void;
	calendar?: Calendar;
	sendWorkplaceId?: boolean;
}

export default function CalendarPatientEventModal(
	props: ICalendarPatientEventModal,
) {
	const {
		opened,
		onClose,
		selectedDate,
		patientId,
		caseId,
		workplaceId,
		defaultData,
		params,
		onEventIsCreated,
		healthPlanCode,
		onSuccess,
		calendar,
		sendWorkplaceId,
	} = props;
	const { isCase } = useTreatmentContext();

	return (
		<div className={styles.wrapper}>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header
					title={
						defaultData ? 'base.editPatientOrder' : 'base.shared.orderAPatient'
					}
					firstUpper
				/>
				<Modal.Content contentScroll={true}>
					<CalendarPatientEvent
						healthPlanCode={healthPlanCode}
						caseId={caseId}
						order={defaultData}
						selectedDate={selectedDate}
						patientId={patientId}
						onSuccess={onSuccess ?? onClose}
						workplaceId={workplaceId}
						params={params}
						onEventIsCreated={onEventIsCreated}
						calendar={calendar}
						sendWorkplaceId={sendWorkplaceId}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
}
